module.exports = __webpack_public_path__ + "img/france-external-causes-male.9da1d2b1.png";